import Vue from 'vue'
import Router from 'vue-router'
import Token from './views/Token.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:token',
      name: 'Token',
      component: Token
    }
  ]
})
